import { createContext } from "react";

export const PMStateContext = createContext();
